export const DayConstShortMap: Record<string, string> = {
    Monday:"Mon",
    Tuesday:"Tue",
    Wednesday:"Wed",
    Thursday:"Thu",
    Friday:"Fri",
    Saturday:"Sat",
    Sunday:"Sun"
}